// Public search API for the Haydock reader.

import { getIndex } from "./loadIndex";
import { parseStructural } from "./parseQuery";

/**
 * search(rawQuery, opts) → Promise<
 *   { kind: 'nav', target: string }
 *   | { kind: 'results', hits: Array, total: number }
 *   | { kind: 'empty' }
 * >
 *
 * opts:
 *   testament: 'nt' | 'ot' | 'both' (default 'both')
 *   type: 'verse' | 'note' | undefined (default both)
 *   bookSlug: string | undefined
 *   limit: number (default 200; UI paginates client-side)
 */
export async function search(rawQuery, opts = {}) {
  const q = String(rawQuery || "").trim();
  if (!q) return { kind: "empty" };

  const target = parseStructural(q);
  if (target) return { kind: "nav", target };

  const indexes = await getIndex(opts.testament ?? "both");

  const filterFn = (hit) => {
    if (opts.type && hit.type !== opts.type) return false;
    if (opts.bookSlug && hit.bookSlug !== opts.bookSlug) return false;
    return true;
  };

  const allHits = indexes.flatMap((idx) =>
    idx.search(q, {
      boost: { attribution: 4, book: 2 },
      fuzzy: 0.2,
      prefix: true,
      combineWith: "AND",
      filter: filterFn,
    }),
  );
  allHits.sort((a, b) => b.score - a.score);

  const limit = opts.limit ?? 200;
  return {
    kind: "results",
    hits: allHits.slice(0, limit),
    total: allHits.length,
  };
}

export { parseStructural } from "./parseQuery";
export { buildSnippet } from "./snippet";
